import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import { WEBSITE_SERVICE } from "../content";
import { CtaBand, SectionHead, useSeo } from "../ui";
import { PRODUCT_SEGMENTS, SECRET_NOTE, contactLink } from "./content";
import { OptionCards } from "./LandingPage";
import { trackVisit } from "./tracking";

/* =========================================================
   허브 — "어떤 분이신가요?" → 분야 선택
   안내 페이지가 준비된 분야는 랜딩으로, 아직인 분야는 바로 문의로 보낸다
   (문의에 분야가 기록되므로 준비 전 분야의 수요도 확인할 수 있다).
   ========================================================= */
export default function LandingHub() {
  useSeo({
    title: "어떤 분이신가요? 분야별 제품 개발 안내 | I.META",
    description:
      "개발 조직이 없는 개인·소규모 사업자의 아이디어를 회로·PCB·펌웨어·서버·웹까지 한 곳에서, 빠르고 합리적으로 만듭니다. 분야를 고르시면 맞춤 안내를 보여 드립니다.",
    path: "/for",
  });

  useEffect(() => {
    trackVisit("hub");
  }, []);

  return (
    <>
      <section className="lp-hero lp-hero--hub">
        <div className="lp-hero__inner">
          <div className="kicker">For you</div>
          <h1 className="lp-hero__title">어떤 분이신가요?</h1>
          <p className="lp-hero__lead">
            아이디어는 있는데 개발 조직과 개발비가 없다면. 회로·PCB·펌웨어·서버·웹까지 한 곳에서 빠르고 합리적으로
            만듭니다. 분야를 고르시면 그 분야에 맞춘 진행 방법과 제작 예시를 보여 드립니다.
          </p>
        </div>
      </section>

      <section className="section section--tight">
        <div className="lp-hub">
          {PRODUCT_SEGMENTS.map((s) => {
            const I = Icon[s.icon];
            const to = s.ready ? `/for/${s.slug}` : contactLink(s.slug);
            return (
              <Link key={s.slug} to={to} className={`lp-hub__item ${s.ready ? "" : "lp-hub__item--soon"}`}>
                <span className="card__icon lp-hub__icon">
                  {I ? <I width="20" height="20" aria-hidden="true" focusable="false" /> : null}
                </span>
                <span className="lp-hub__text">
                  <strong className="lp-hub__label">{s.label}</strong>
                  <span className="lp-hub__who">{s.who}</span>
                </span>
                <span className="lp-hub__go">
                  {s.ready ? "맞춤 안내" : "바로 문의"}
                  <Icon.ArrowRight width="14" height="14" aria-hidden="true" focusable="false" />
                </span>
              </Link>
            );
          })}
          <Link to={contactLink("")} className="lp-hub__item lp-hub__item--etc">
            <span className="card__icon lp-hub__icon">
              <Icon.Mail width="20" height="20" aria-hidden="true" focusable="false" />
            </span>
            <span className="lp-hub__text">
              <strong className="lp-hub__label">해당하는 분야가 없나요?</strong>
              <span className="lp-hub__who">어떤 아이디어든 먼저 이야기해 주세요.</span>
            </span>
            <span className="lp-hub__go">
              바로 문의 <Icon.ArrowRight width="14" height="14" aria-hidden="true" focusable="false" />
            </span>
          </Link>
        </div>

        {/* 제품 개발이 아닌 가게 홈페이지 — 따로 안내 */}
        <div className="lp-hub-web">
          <Link to="/for/website" className="lp-hub__item">
            <span className="card__icon lp-hub__icon">
              <Icon.Globe width="20" height="20" aria-hidden="true" focusable="false" />
            </span>
            <span className="lp-hub__text">
              <strong className="lp-hub__label">가게 홈페이지가 필요하신가요?</strong>
              <span className="lp-hub__who">
                식당 · 카페 · 미용실 · 공방 · 학원 등 손님은 이제 AI에게 물어봅니다. 블로그 광고 대신 내 가게 공식 홈페이지 — {WEBSITE_SERVICE.price}.
              </span>
            </span>
            <span className="lp-hub__go">
              홈페이지 안내 <Icon.ArrowRight width="14" height="14" aria-hidden="true" focusable="false" />
            </span>
          </Link>
        </div>
      </section>

      <section className="section">
        <SectionHead
          kicker="Options"
          title="진행 방식은 세 가지입니다"
          desc="아이디어와 상황에 맞는 방식을 상담에서 함께 정합니다."
        />
        <OptionCards options={null} />
      </section>

      <CtaBand title="아이디어 한 줄이면 충분합니다" desc={SECRET_NOTE} to={contactLink("")} label="문의하기" />
    </>
  );
}
